import {
  Droplets,
  Hammer,
  HardHat,
  Paintbrush,
  Wind,
  Wrench,
  Zap,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { LANDING_IMAGES } from "../../../../constants/landing-images";

const ICON_REGISTRY: Record<string, LucideIcon> = {
  Droplets,
  Hammer,
  HardHat,
  Paintbrush,
  Wind,
  Wrench,
  Zap,
};

export const resolveTradeIcon = (name: string): LucideIcon =>
  ICON_REGISTRY[name] ?? Wrench;

export const resolveTradeImage = (imageKey: string): string =>
  (LANDING_IMAGES as Record<string, string>)[imageKey] ??
  LANDING_IMAGES.general;
